import { Box, useColorModeValue as mode } from "@chakra-ui/react";

/**
 * The brand "glow frame" — a gradient ring (brand purple → Schnerp orange) plus
 * a soft purple glow, wrapping a surface-filled interior. Used to make a page's
 * primary action pop: the homepage search box and the single-facility
 * availability calendar both sit inside one.
 *
 * Pass layout props (mt, maxW, id, sx…) to the outer frame; `innerProps` styles
 * the surface interior (padding, etc.).
 */
export function GlowFrame({ children, innerProps, ...props }) {
  return (
    <Box
      position="relative"
      zIndex={2}
      borderRadius="2xl"
      p="2px"
      bgGradient={mode(
        "linear(135deg, brand.500 0%, brand.400 55%, orange.400 100%)",
        "linear(135deg, brand.300 0%, brand.400 55%, orange.300 100%)",
      )}
      boxShadow={mode(
        "0 20px 45px -18px rgba(98,90,250,0.45), 0 4px 12px -6px rgba(0,0,0,0.12)",
        "0 20px 55px -18px rgba(98,90,250,0.6)",
      )}
      {...props}
    >
      <Box bg="bg-surface" borderRadius="14px" {...innerProps}>
        {children}
      </Box>
    </Box>
  );
}
